import { Link } from "react-router-dom";

export const LogoInline = ({ className = "", testId = "nav-logo" }) => (
  <Link to="/" aria-label="Quantivo home" data-testid={testId} className={`group flex items-center gap-2.5 ${className}`}>
    <img src="/brand/mark-dark.webp" alt="" width="300" height="243" className="h-8 w-auto transition-transform duration-500 group-hover:-rotate-6" />
    <img src="/brand/wordmark-dark.webp" alt="Quantivo" width="600" height="81" className="h-[15px] w-auto" />
  </Link>
);

export const LogoFull = ({ variant = "dark", className = "" }) =>
  variant === "dark" ? (
    <img src="/brand/logo-dark.webp" alt="Quantivo logo — Innovate. Automate. Scale." width="900" height="578" loading="lazy" className={className} />
  ) : (
    <img src="/brand/logo-light.webp" alt="Quantivo logo — Innovate. Automate. Scale." width="900" height="574" loading="lazy" className={className} />
  );
